import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent, { mocked } from 'agent'

import appMode from 'helpers/getAppMode'

import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywordDiscovery.actions'
import {
  getDomainKeywordDiscoveryFailure,
  getDomainKeywordDiscoverySuccess
} from 'redux/actions/keywordDiscovery.actions'

function* getDomainKeywordDiscoverySaga(params) {
  try {
    const { domainId, filters } = params.payload
    const endpoint = appMode.share
      ? agent.Share.discovery
      : appMode.preview
      ? mocked.Domains.discovery
      : agent.Domains.discovery

    const body = yield call(endpoint, domainId, filters)
    const discovery = body.data
    yield put(getDomainKeywordDiscoverySuccess(discovery, domainId))
  } catch (error) {
    yield put(getDomainKeywordDiscoveryFailure(error))
  }
}

function* exportKeywordDiscoveryExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportDiscoveryExcel,
    requestShared: agent.Share.exportShareDiscoveryExcel
  })
}

function* exportKeywordDiscoveryCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportDiscoveryCSV,
    requestShared: agent.Share.exportShareDiscoveryCSV
  })
}

export default function* keywordDiscoverySagas() {
  yield all([
    takeLatest(actions.getDomainKeywordDiscovery.type, getDomainKeywordDiscoverySaga),
    takeLatest(actions.exportDomainKeywordDiscoveryExcel.type, exportKeywordDiscoveryExcelSaga),
    takeLatest(actions.exportDomainKeywordDiscoveryCSV.type, exportKeywordDiscoveryCSVSaga)
  ])
}
